import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import ErrorBoundary0 from '@lc/error-boundary';
import sls from '@lcai/console-sls';
import { jsx as _jsx } from "react/jsx-runtime";
function onErrorCaught(error, errorInfo) {
  sls.error({
    flatten: true
  }, 'error_boundary', {
    error: error,
    errorInfo: errorInfo
  });
}
export default function ErrorBoundary(props) {
  return /*#__PURE__*/_jsx(ErrorBoundary0, _objectSpread({}, _objectSpread(_objectSpread({}, props), {}, {
    onErrorCaught: onErrorCaught
  })));
}
//# sourceMappingURL=index.js.map